export function Message({ message }: { message: string }) {
  return <div className="flex mt-4 mb-4 justify-center px-4">{message}</div>;
}
